import React from "react";
import {Icon} from "./Icon.jsx";

const BOX={sm:28,md:36,lg:44};

export function IconButton({icon,label,variant="ghost",size="md",disabled=false,style,...rest}){
  const [hover,setHover]=React.useState(false);
  const base=variant==="outline"
    ?{background:"transparent",border:"1px solid var(--line-default)",color:"var(--fg-1)"}
    :variant==="solid"
    ?{background:"var(--surface-brand)",border:"1px solid var(--surface-brand)",color:"var(--fg-invert)"}
    :{background:"transparent",border:"1px solid transparent",color:"var(--fg-2)"};
  const hov=variant==="solid"
    ?{background:"var(--teal-600)",borderColor:"var(--teal-600)"}
    :{background:"var(--surface-sunken)",color:"var(--fg-1)"};
  return (
    <button aria-label={label} title={label} disabled={disabled}
      onMouseEnter={()=>setHover(true)} onMouseLeave={()=>setHover(false)}
      style={{width:BOX[size],height:BOX[size],display:"inline-flex",alignItems:"center",justifyContent:"center",
        borderRadius:"var(--radius-control)",cursor:disabled?"not-allowed":"pointer",padding:0,
        opacity:disabled?0.4:1,transition:"var(--transition-control)",
        ...base,...(hover&&!disabled?hov:null),...style}}
      {...rest}>
      {typeof icon==="string"?<Icon name={icon} size={size==="sm"?15:size==="lg"?20:17} strokeAlign="middle"/>:icon}
    </button>
  );
}
